import * as React from "react";
import { CSVFileInput } from "src/components/TaskListPanel/TaskListPanel.components";
import {
  ChooseCSVButton,
  DragAndDropCSVLabel,
  ImportCSVLabel,
  ImportTasksPanelWrapper,
} from "src/components/TaskUploader/TaskUploader.components";

export interface Props {
  onHandleChange: (_handleEvent: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectionChange: (_selectedFile: File) => void;
}

const TaskSelection: React.FunctionComponent<Props> = ({
  onHandleChange,
  onSelectionChange,
}) => {
  const fileSelectionRef = React.useRef<HTMLInputElement>(null);
  const [drag, setDrag] = React.useState(false);

  const handleClick = () => {
    fileSelectionRef?.current?.click();
  };

  const handleDragStart = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.clearData();
  };

  const handleDrag = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragIn = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (e?.dataTransfer?.items?.length === 1) {
      setDrag(true);
    }
  };

  const handleDragOut = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (drag) {
      setDrag(false);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    setDrag(false);
    if (e?.dataTransfer?.files?.length === 1) {
      onSelectionChange(e.dataTransfer.files[0]);
    }
  };

  return (
    <ImportTasksPanelWrapper
      fileOverPanel={drag}
      onDragOver={handleDrag}
      onDragEnter={handleDragIn}
      onDragLeave={handleDragOut}
      onDrop={handleDrop}
      onDragStart={handleDragStart}>
      <ImportCSVLabel>Import CSV</ImportCSVLabel>
      <DragAndDropCSVLabel>
        Drag and drop <br /> or
      </DragAndDropCSVLabel>
      <ChooseCSVButton themeColor="background" onClick={handleClick}>
        Select CSV file
      </ChooseCSVButton>
      <CSVFileInput
        data-testid="csvFileInput"
        type="file"
        ref={fileSelectionRef}
        onChange={onHandleChange}
      />
    </ImportTasksPanelWrapper>
  );
};

export default TaskSelection;
